<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Popover, Table } from 'ant-design-vue'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import { BaseBooleanStatusRender } from '@/constant'
const [name, bem] = createNamespace('TotalAmountCell')
export default defineComponent({
  name,
  props: {
    totalAmount: {
      type: Number,
      default: 0
    },
    members: {
      type: Array as PropType<ApiFamilyMembers.Item[]>,
      default: () => []
    }
  },
  setup(props) {
    const memberColumns = [
      {
        title: '姓名',
        dataIndex: 'userName',
        width: 200
      },
      {
        title: '户口类型',
        dataIndex: 'isFarmer',
        width: 100,
        customRender({ text }) {
          return BaseBooleanStatusRender(text, ['非农业', '农业'])
        }
      },
      {
        title: '是否不予安置',
        dataIndex: 'isAnZhi',
        width: 100,
        customRender({ text }) {
          return BaseBooleanStatusRender(text)
        }
      }
    ]
    const renderMembers = () => (
      <Popover content={<Table pagination={false} dataSource={props.members} columns={memberColumns} size='small' />} trigger='hover'>
        <QuestionCircleOutlined class={bem('icon')} />
      </Popover>
    )
    return () => (
      <div class={bem()}>
        <span>{props.totalAmount}</span>
        {renderMembers()}
      </div>
    )
  }
})
</script>

<style lang="less">
.total-amount-cell {
  &__icon {
    margin-left: @margin-xs;
    color: @gray;
  }
}
</style>
